export default "__VITE_ASSET__035ee851__"